import * as React from 'react';
import * as Classes from '../common/classes';
import classNames from 'classnames';
import { IProps } from '../common/props';
import { CSSProperties, useLayoutEffect } from 'react';

export interface IInputGroupProps extends IProps {
  rightElement?: React.ReactElement;
  leftElement?: React.ReactElement;
  inputRef?: React.RefObject<HTMLInputElement>;
  inputClassName?: string;
}

export type InputGroupProps = IInputGroupProps &
  React.InputHTMLAttributes<HTMLInputElement>;

export const InputGroup: React.FC<InputGroupProps> = ({
  className,
  inputClassName,
  children,
  style,
  title,
  dataTest,
  leftElement,
  rightElement,
  inputRef,
  value,
  autoFocus,
  ...other
}) => {
  const [rightElementWidth, setRightElementWidth] = React.useState<number>(0);
  const [leftElementWidth, setLeftElementWidth] = React.useState<number>(0);
  const rightElementRef = React.useRef<HTMLSpanElement>(null);
  const leftElementRef = React.useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    if (rightElementRef.current) {
      let clientWidth = rightElementRef.current.clientWidth;
      if (Math.abs(rightElementWidth - clientWidth) > 2) {
        setRightElementWidth(clientWidth);
      }
    }
    if (leftElementRef.current) {
      let clientWidth = leftElementRef.current.clientWidth;
      if (Math.abs(leftElementWidth - clientWidth) > 2) {
        setLeftElementWidth(clientWidth);
      }
    }
  }, [rightElementRef.current]);

  const inputStyle: CSSProperties = { ...style };
  if (leftElementRef.current) {
    inputStyle.paddingLeft = leftElementWidth;
  }
  if (rightElementRef.current) {
    inputStyle.paddingRight = rightElementWidth;
  }

  return (
    <div
      data-test={dataTest ? `input-grroup-${dataTest}` : undefined}
      className={classNames(className, Classes.INPUT_GROUP)}
    >
      <input
        value={value}
        ref={inputRef}
        title={title}
        className={classNames(
          Classes.INPUT_GROUP_INPUT,
          Classes.INPUT,
          inputClassName
        )}
        style={inputStyle}
        autoFocus={autoFocus}
        {...other}
      />
      {leftElement && (
        <span className={Classes.INPUT_GROUP_LEFT} ref={leftElementRef}>
          {leftElement}
        </span>
      )}
      {rightElement && (
        <span className={Classes.INPUT_GROUP_RIGHT} ref={rightElementRef}>
          {rightElement}
        </span>
      )}
    </div>
  );
};
